// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    -moz-osx-font-smoothing: grayscale;
}
html,
body,
#app {
    width: 100%;
    height: 100%;
    margin: 0;
    background-color: #e9e9e9;
}
`, "",{"version":3,"sources":["webpack://./src/ui/index.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC;AACA;;;IAGI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,yBAAyB;AAC7B","sourcesContent":["html {\n    -moz-osx-font-smoothing: grayscale;\n}\nhtml,\nbody,\n#app {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    background-color: #e9e9e9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
